import { LastViewedObject } from "../../types/types";
import Page from "../Page";
import useFetchPage from "../hooks/useFetchPage";
import Boxes from "./Boxes";

interface Props {
  setLastViewed: (value: LastViewedObject) => void;
}

const Contact = ({ setLastViewed }: Props) => {
  const page = useFetchPage(setLastViewed);

  return (
    page && (
      <Page title={page.frontmatter.title}>
        <Boxes frontmatter={page.frontmatter} />
      </Page>
    )
  );
};

export default Contact;
